module.exports = __webpack_public_path__ + "static/media/web-kio3@2x.ba46c269.png";